export default {
  organizations: [],
  onboardingSettings: []
};
